import GoogleMapsSuggestor from '../../../common/scripts/address_suggestors/google-maps-suggestor';
import { addMarker, initGoogleMaps } from '../../../common/scripts/helpers/google-maps';

const initAddressAutocomplete = (addressValidation) => {
  if (typeof google === 'undefined') {
    // inform if someone blocks google maps
    alert('Google Maps is not available. The site won\'t work without it.');
  }
  let { map, markers } = initGoogleMaps();
  new GoogleMapsSuggestor(addressValidation).attach(map);

  $('#address-input-group').on('validate', () => {
    const coordinates = {
      lat: parseFloat($('#latitude').val()),
      lng: parseFloat($('#longitude').val()),
    };
    markers.splice(0, markers.length).forEach(marker => marker.setMap(null));
    map.setCenter(coordinates);
    markers.push(addMarker(map, $('#map')[0], coordinates));
  });
};

export { initAddressAutocomplete };
